import { Select } from './Select';
import { SelectProps } from '../types';
import { ImageOption } from './ImageOption';

type ComponentImageSelectProps = Omit<SelectProps<string>, 'options'> & {
  images: { label?: string; url: string }[];
};

export const ComponentImageSelect = ({
  images,
  ...selectProps
}: ComponentImageSelectProps) => (
  <Select
    {...selectProps}
    options={images.map(({ label, url }) => ({
      label: label || url,
      value: url,
      leftContent: <ImageOption src={url} loading="lazy" />,
    }))}
  />
);

type ComponentThumbnailSelectProps = Omit<SelectProps<string>, 'options'> & {
  images: { label?: string; url: string }[];
  description: string;
};

export const ComponentThumbnailSelect = ({
  images,
  description,
  ...selectProps
}: ComponentThumbnailSelectProps) => (
  <Select
    {...selectProps}
    options={images.map(({ label, url }) => ({
      label: label || url,
      value: url,
      description: description,
      rightContent: <object data={url} />,
    }))}
  />
);
